import React, { useState } from "react";
import { LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import { App, Button, Input, Spin } from "antd";
import { useClientSearch } from "hook/clients/useClient";
import { useSelector } from "react-redux";
import { FaQrcode } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import {
  defaultClientInfoSelector,
  defaultClientTypeSelector,
} from "store/user/(default)/client/default_client.selector";
import { setDefaultClientType } from "store/user/(default)/client/default_client.action";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ClientSearch = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  const { loading, handleSearchByEmail } = useClientSearch();
  // -------------------------- STATE ---------------------------
  const [email, setEmail] = useState("");
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const clientInfo = useSelector(defaultClientInfoSelector);
  const type = useSelector(defaultClientTypeSelector);
  const enabled = !clientInfo && type === "email";
  // -------------------------- FUNCTION ------------------------
  const handleSearch = (e) => {
    const key = e?.key;
    if (key !== "Enter") {
      return;
    }

    if (email === "") return message.error("Vui lòng nhập email");
    return handleSearchByEmail({ email });
  };

  const handleSwitchQR = () => {
    dispatch(setDefaultClientType("qr"));
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const QRButton = () => {
    return (
      <Button
        onClick={handleSwitchQR}
        icon={
          <span className="anticon">
            <FaQrcode />
          </span>
        }
        type="link"
      >
        Tìm kiếm QR
      </Button>
    );
  };

  const renderLoading = () => {
    if (loading) return <Spin indicator={<LoadingOutlined spin />} />;
    return <span style={{ color: "#aeaeae" }}>Nhấn Enter để tìm kiếm</span>;
  };

  // -------------------------- MAIN ----------------------------
  if (!enabled) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontWeight: "bold" }}>Tìm kiếm theo email</span>
        <QRButton />
      </div>
      <Input
        placeholder="Tìm kiếm người"
        style={{ background: "#f6f6f6" }}
        prefix={<SearchOutlined />}
        onChange={(e) => setEmail(e?.target?.value)}
        onKeyUp={handleSearch}
        suffix={renderLoading()}
      />
    </div>
  );
};
export default ClientSearch;
